module.exports = {"460203198":"吉阳镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/460203.json
// module id = 2189
// module chunks = 0